import React, { useCallback } from "react";

import { matchPhrases } from "../../../utils/utilities";
import { PDOChecklistItem } from "./pdoCheckList";

import Conditional from "../../common/conditional";
import CustomVisualInspectionSummary from "../custom-utm/custom-utm-summary";
import CustomGeneralPhotos from "../custom-general/custom-general-photos";
import CustomUTMAnomaly from "../custom-utm/customUTMAnomaly";

interface Props {
    section: string;
    checklistItems: PDOChecklistItem[];
}

const PDOAnomalyReport: React.FC<Props> = ({ checklistItems, section }) => {
    const getAnomalyHeaders = useCallback((item: PDOChecklistItem) => {
        return [
            {
                label: 'Tank Section',
                value: item.label,
            },
        ];
    }, []);

    return (  
        <>
            {checklistItems.map((checklistItem, index) => (
                <React.Fragment key={checklistItem.label}>
                    <Conditional isVisible={matchPhrases(checklistItem.hasAnomalies, 'yes')}>
                        <CustomVisualInspectionSummary anomalyItems={checklistItem.anomalyItems} sectionTitle={section} />
                        
                        <CustomUTMAnomaly
                            includePDO
                            lineNumberID={index + 1}
                            anomalyItems={checklistItem.anomalyItems}
                            headers={getAnomalyHeaders(checklistItem)}
                        />
                    </Conditional>

                    <Conditional isVisible={checklistItem.generalPhotos.length > 0}>
                        <CustomGeneralPhotos identifier={checklistItem.label} label={section} subLabel="Photographic Record" photos={checklistItem.generalPhotos} />
                    </Conditional>
                </React.Fragment>
            ))}
        </>
    );
}
 
export default PDOAnomalyReport;